"use strict";
import p from "./index.es99.js";
import q from "./index.es138.js";
import y from "./index.es139.js";
import k from "./index.es140.js";
import d from "./index.es102.js";
import v from "./index.es141.js";
import m from "./index.es142.js";
import A from "./index.es113.js";
const i = m.validators;
class w {
  constructor(r) {
    this.defaults = r || {}, this.interceptors = {
      request: new y(),
      response: new y()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(r, t) {
    try {
      return await this._request(r, t);
    } catch (s) {
      if (s instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          s.stack ? o && !String(s.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + o) : s.stack = o;
        } catch {
        }
      }
      throw s;
    }
  }
  _request(r, t) {
    typeof r == "string" ? (t = t || {}, t.url = r) : t = r || {}, t = d(this.defaults, t);
    const { transitional: s, paramsSerializer: a, headers: o } = t;
    s !== void 0 && m.assertOptions(s, {
      silentJSONParsing: i.transitional(i.boolean),
      forcedJSONParsing: i.transitional(i.boolean),
      clarifyTimeoutError: i.transitional(i.boolean)
    }, !1), a != null && (p.isFunction(a) ? t.paramsSerializer = {
      serialize: a
    } : m.assertOptions(a, {
      encode: i.function,
      serialize: i.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), m.assertOptions(t, {
      baseUrl: i.spelling("baseURL"),
      withXsrfToken: i.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let E = o && p.merge(
      o.common,
      o[t.method]
    );
    o && p.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (e) => {
        delete o[e];
      }
    ), t.headers = A.concat(E, o);
    const h = [];
    let b = !0;
    this.interceptors.request.forEach(function(e) {
      typeof e.runWhen == "function" && e.runWhen(t) === !1 || (b = b && e.synchronous, h.unshift(e.fulfilled, e.rejected));
    });
    const f = [];
    this.interceptors.response.forEach(function(e) {
      f.push(e.fulfilled, e.rejected);
    });
    let l, n = 0, u;
    if (!b) {
      const e = [k.bind(this), void 0];
      for (e.unshift(...h), e.push(...f), u = e.length, l = Promise.resolve(t); n < u; )
        l = l.then(e[n++], e[n++]);
      return l;
    }
    u = h.length;
    let g = t;
    for (; n < u; ) {
      const e = h[n++], S = h[n++];
      try {
        g = e(g);
      } catch (U) {
        S.call(this, U);
        break;
      }
    }
    try {
      l = k.call(this, g);
    } catch (e) {
      return Promise.reject(e);
    }
    for (n = 0, u = f.length; n < u; )
      l = l.then(f[n++], f[n++]);
    return l;
  }
  getUri(r) {
    r = d(this.defaults, r);
    const t = v(r.baseURL, r.url, r.allowAbsoluteUrls);
    return q(t, r.params, r.paramsSerializer);
  }
}
p.forEach(["delete", "get", "head", "options"], function(c) {
  w.prototype[c] = function(r, t) {
    return this.request(d(t || {}, {
      method: c,
      url: r,
      data: (t || {}).data
    }));
  };
});
p.forEach(["post", "put", "patch"], function(c) {
  function r(t) {
    return function(s, a, o) {
      return this.request(d(o || {}, {
        method: c,
        headers: t ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: a
      }));
    };
  }
  w.prototype[c] = r(), w.prototype[c + "Form"] = r(!0);
});
export {
  w as default
};
//# sourceMappingURL=index.es101.js.map
